import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';

@Component({
  selector: 'textareaControl',
  templateUrl: './textarea-control.component.html',
  styleUrls: ['./textarea-control.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class TextAreaControlComponent implements OnInit {

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  @Input() formControlFieldName: string;
  @Input() placeholder: string = "Enter text";
  @Input() mxLength: number = 100;
  @Input() mnRows: string = "1";
  @Input() mxRows: string = "6";
  
  public formGroup: FormGroup;
  public displayRemain: number;

  constructor(private ctrlContainer: FormGroupDirective, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.displayRemain = this.mxLength;
    const control = new FormControl('');
    this.formGroup = this.ctrlContainer.form;
    this.formGroup.addControl(this.formControlFieldName, control);
  }

  ngAfterViewInit() {
    this.formGroup.controls[this.formControlFieldName].valueChanges.subscribe(value => {
      this.displayRemain = Number(this.mxLength) - (value === null ? 0 : Number(value.trim()?.length));
    });
  }

  triggerResize() {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

}